import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastService } from '../services/toast/toast.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServerResponse, IServerResponse } from '../models/server-response.model';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {

  const toastService = inject(ToastService);

  return next(req).pipe(
    map((event) => {

      // console.log('HTTP Event:', event);      

      if (event instanceof HttpResponse) {
        const body = event.body;

        // Validar que tenga estructura de IServerResponse
        if (
          body instanceof ServerResponse &&
          body.statusCode !== 200 &&
          body.statusCode !== 201
        ) {
          
          const { statusCode, message, data } = body;
          
          toastService.show({
            header: `Error evento ${statusCode}`,
            body: message,
            classname: 'bg-danger text-white'
          });

          throw {
            message,
            statusCode,
            original: body
          };
          
        }

        return event.clone({
          body
        });
      }

      return event;
    }),

    catchError((error: any) => {

      let formattedError = {
        message: error.message ?? 'Error desconocido',
        statusCode: 500,
        original: error
      };
      
      if (error instanceof HttpErrorResponse) {

        // console.log(error);

        formattedError = {
          message: error.message || error.statusText || 'Error en la solicitud',
          statusCode: error.status,
          original: error
        };
      }

      toastService.show({
        header: `Error ${formattedError.statusCode}`,
        body: `${formattedError.message}`,
        classname: 'bg-danger text-white'
      });

      return throwError(() => formattedError);
    })
  );

};
